<template>
	<v-dialog :fullscreen="isMobile" v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title class="headline modal__title">
				<button type="button" class="btn-flat-icon--dark" @click="open=false"><v-icon large>fal fa-times</v-icon></button>
			</v-card-title>
			<v-card-text :style="getStyle" class="modal__card-text basic-modal-padding">
				<div style="min-height: 80%; display: flex; flex-direction: column; justify-content: center;">
					<add-event-intro v-if="page === 'host_add_event_intro'"></add-event-intro>
					<add-event-location v-if="page === 'host_add_event_location'"></add-event-location>
					<add-event-type v-if="page === 'host_add_event_type'"></add-event-type>
					<add-event-schedule v-if="page === 'host_add_event_schedule'"></add-event-schedule>
					<add-event-description v-if="page === 'host_add_event_description'"></add-event-description>
					<add-event-seating v-if="page === 'host_add_event_seating'"></add-event-seating>
					<add-event-amenities v-if="page === 'host_add_event_amenities'"></add-event-amenities>
					<add-event-restrictions v-if="page === 'host_add_event_restrictions'"></add-event-restrictions>
					<add-event-notes v-if="page === 'host_add_event_notes'"></add-event-notes>
					<add-event-photos v-if="page === 'host_add_event_photos'"></add-event-photos>
					<add-event-extras v-if="page === 'host_add_event_extras'"></add-event-extras>
					<add-event-format v-if="page === 'host_add_event_format'"></add-event-format>
					<add-event-submit v-if="page === 'host_add_event_submit'"></add-event-submit>

					<add-location-intro v-if="page === 'host_add_location_intro'"></add-location-intro>
					<add-location-location v-if="page === 'host_add_location_location'"></add-location-location>
					<add-location-type v-if="page === 'host_add_location_type'"></add-location-type>
					<add-location-seating v-if="page === 'host_add_location_seating'"></add-location-seating>
					<add-location-amenities v-if="page === 'host_add_location_amenities'"></add-location-amenities>
					<add-location-description v-if="page === 'host_add_location_description'"></add-location-description>
					<add-location-photos v-if="page === 'host_add_location_photos'"></add-location-photos>
					<add-location-submit v-if="page === 'host_add_location_submit'"></add-location-submit>

					<host-process-apply v-if="page === 'host_apply'"></host-process-apply>
					<host-process-space v-if="page === 'host_space'"></host-process-space>
				</div>
				<div>
					<img class="event-page-flat-logo mb-3 mt-3" src="/static/images/wrkprty-flattened-logo.png" alt="">
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AddEventIntro from '~/components/modals/host_process_modal_content/AddEventIntro.vue'
import AddEventLocation from '~/components/modals/host_process_modal_content/AddEventLocation.vue'
import AddEventType from '~/components/modals/host_process_modal_content/AddEventType.vue'
import AddEventSchedule from '~/components/modals/host_process_modal_content/AddEventSchedule.vue'
import AddEventDescription from '~/components/modals/host_process_modal_content/AddEventDescription.vue'
import AddEventSeating from '~/components/modals/host_process_modal_content/AddEventSeating.vue'
import AddEventAmenities from '~/components/modals/host_process_modal_content/AddEventAmenities.vue'
import AddEventRestrictions from '~/components/modals/host_process_modal_content/AddEventRestrictions.vue'
import AddEventNotes from '~/components/modals/host_process_modal_content/AddEventNotes.vue'
import AddEventPhotos from '~/components/modals/host_process_modal_content/AddEventPhotos.vue'
import AddEventExtras from '~/components/modals/host_process_modal_content/AddEventExtras.vue'
import AddEventFormat from '~/components/modals/host_process_modal_content/AddEventFormat.vue'
import AddEventSubmit from '~/components/modals/host_process_modal_content/AddEventSubmit.vue'

import AddLocationIntro from '~/components/modals/host_process_modal_content/AddLocationIntro.vue'
import AddLocationLocation from '~/components/modals/host_process_modal_content/AddLocationLocation.vue'
import AddLocationType from '~/components/modals/host_process_modal_content/AddLocationType.vue'
import AddLocationSeating from '~/components/modals/host_process_modal_content/AddLocationSeating.vue'
import AddLocationAmenities from '~/components/modals/host_process_modal_content/AddLocationAmenities.vue'
import AddLocationDescription from '~/components/modals/host_process_modal_content/AddLocationDescription.vue'
import AddLocationPhotos from '~/components/modals/host_process_modal_content/AddLocationPhotos.vue'
import AddLocationSubmit from '~/components/modals/host_process_modal_content/AddLocationSubmit.vue'

import HostProcessApply from '~/components/modals/host_process_modal_content/HostProcessApply.vue'
import HostProcessSpace from '~/components/modals/host_process_modal_content/HostProcessSpace.vue'

export default {
	components: {
		HostProcessApply,
		HostProcessSpace,
		AddLocationIntro,
		AddLocationLocation,
		AddLocationType,
		AddLocationSeating,
		AddLocationAmenities,
		AddLocationDescription,
		AddLocationPhotos,
		AddLocationSubmit,
		AddEventIntro,
		AddEventLocation,
		AddEventType,
		AddEventSchedule,
		AddEventDescription,
		AddEventSeating,
		AddEventAmenities,
		AddEventRestrictions,
		AddEventNotes,
		AddEventPhotos,
		AddEventExtras,
		AddEventFormat,
		AddEventSubmit
	},
	name: 'HostProcessModal',
	methods: {
		...mapActions(['setModalOpen'])
	},
	computed: {
		...mapGetters(['getModalProp']),
		open: {
			get() {
				return this.getModalProp('hostProcessModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'hostProcessModal', value: val })
			}
		},
		page() {
			return this.getModalProp('hostProcessModalPage')
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		},
		getStyle() {
			let style = {}
			if (this.isMobile) {
				style = {
					height: '100%'
				}
				return style
			}
		}
	}
}
</script>
